module.exports = __webpack_public_path__ + "img/pdf.4dd93349.svg";